const styles = theme => ({
  orgLink: {
    marginBottom: theme.spacing(1),
    cursor: "pointer"
  },
  code: {
    color: theme.palette.primary.light
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(2)
  },
  link: {
    padding: `0 0 ${theme.spacing(2)}px ${theme.spacing(1)}px`,
    color: theme.palette.primary.default,
    width: "100%"
  },
  linkText: {
    color: theme.palette.primary.default,
    "&: hover": {
      color: theme.palette.primary.default
    }
  },
  copyIcon: {
    fontSize: 16
  },
  registerCopy: {
    padding: theme.spacing(1),
    width: 100,
    background: "#fff",
    border: "1px solid rgba(0, 0, 0, 0.46)",
    borderRadius: 4
  },
  codeContainer: {
    height: 54,
    color: theme.palette.primary.default
  },

  addMember: {
    margin: `${theme.spacing(4)}px 0`,
    width: "100%",
    height: 200,
    color: theme.palette.primary.default
  },
  addMemberForm: {
    position: "relative",
    width: "100%"
  },
  inviteForm: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "flex-start",
    width: "100%"
  },
  searchText: {
    color: theme.palette.primary.default
  },
  phoneNumberInput: {
    background: "inherit",
    "&.Mui-disabled": {
      background: "rgba(0, 0, 0, .04)"
    }
  },
  searchResults: {
    position: "relative"
  },
  rightPhoneResult: {
    marginLeft: theme.spacing(3)
  },
  nameText: {
    height: 24,
    color: theme.palette.primary.default
  },
  cancel: {
    color: `${theme.palette.warning.main} !important`
  },
  phoneResultButtons: {
    marginTop: theme.spacing(1),
    "& button:nth-of-type(1)": {
      marginRight: theme.spacing(0.5),
      lineHeight: "14px"
    },
    "& button:nth-of-type(2)": {
      marginLeft: theme.spacing(0.5),
      lineHeight: "14px",
      color: theme.palette.warning.main
    },
    "& span:nth-of-type(1)": {
      marginRight: theme.spacing(0.5),
      lineHeight: "14px"
    },
    "& span:nth-of-type(2)": {
      marginLeft: theme.spacing(0.5),
      lineHeight: "14px"
    }
  },
  phoneResultAvatar: {
    width: 60,
    height: 60
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/components/SideBox/components/InviteLink/styles.js